import {
	Component,
	inject,
	Injectable
} from '@angular/core';

import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef
} from "@angular/material/dialog";

import {
	BaseDialogService,
	NonNullableConfigData,
} from '@tilby/tilby-ui-lib/components/tilby-dialog';

import {
	lastValueFrom
} from 'rxjs';

import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface DataConfirmDialog {
	messageLabel: string;
	titleLabel?: string;
	messageParams?: { [key: string]: string };
	cancelLabel?: string;
	confirmLabel?: string;
	isHtml?: boolean;
	customStyle?: Record<string, any>;
	disableClose?: boolean;
}

@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss'],
	imports: [
		CommonModule,
		MatButtonModule,
		MatDialogActions,
		MatDialogContent,
		MatDialogClose,
		TranslateModule
],
	standalone: true
})
export class ConfirmDialogComponent {
	private sanitizer = inject(DomSanitizer);
	public data: DataConfirmDialog = inject(MAT_DIALOG_DATA);
	protected safeHtml?: SafeHtml;

	constructor() {
		if (this.data.isHtml && this.data.messageLabel) {
			this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.data.messageLabel);
		}
	}
}

@Injectable({
	providedIn: 'root'
})
export class ConfirmDialogService extends BaseDialogService {
	private readonly dialogRef = inject(MatDialog);

	/** Opens the dialog and gives back its reference, for the callers that may have to close it themselves. */
	public open(options: NonNullableConfigData<DataConfirmDialog>): MatDialogRef<ConfirmDialogComponent, boolean | void> {
		const config: NonNullableConfigData<DataConfirmDialog> = {
			...this.switchMobileDesktopDimensions({ width: '600px' }),
			...options,
			data: options.data,
			disableClose: options.disableClose ?? options.data?.disableClose
		};

		return this.dialogRef.open(ConfirmDialogComponent, config);
	}

	public openDialog(options: NonNullableConfigData<DataConfirmDialog>): Promise<boolean | void> {
		return lastValueFrom(this.open(options).afterClosed());
	}

	/**
	 * @deprecated needed for backwards compatibility, use `openDialog` instead
	 * 
	 */
	public show(message: string, options?: { yesLabel?: string, noLabel?: string }): Promise<boolean | void> {
		return this.openDialog({
			data: {
				messageLabel: message,
				cancelLabel: options?.noLabel,
				confirmLabel: options?.yesLabel
			}
		});
	}
}